import { addModal } from 'weblite-web-modal-viewer'
import { StartPremiumFeaturesTrial } from './start-premium-features-trial'

const COMPONENT_ID = 'startPremiumFeaturesTrial'

export const showStartPremiumFeaturesTrialModal = () =>
  addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: StartPremiumFeaturesTrial,
  },
}
